import {
  Button,
  DialogForm,
  Form,
  FormDescription,
  Label,
} from '@ais-ui/ui-core';
import React, { useEffect, useMemo } from 'react';
import { MutatePhysicalForm } from './MutatePhysicalForm';
import { cn } from '@ais-ui/utils';
import { DrawingStyles, useDrawFromDialog } from '@ais-ui/react-openlayers';
import { useLocalization } from '@ais-ui/locale-management';
import { useGetShareGroups } from '@ais-ui/websockets';
import { PiDiamond } from 'react-icons/pi';
import { useAtonContext } from '../AtonContext';

interface SavePhysicalAtonDialogProps {
  mutateType: 'create' | 'edit';
}

export const SavePhysicalAtonDialog = React.memo(
  ({ mutateType }: SavePhysicalAtonDialogProps) => {
    const {
      showDialog,
      setShowDialog,
      isSubmitting,
      physicalForm: form,
      onCreatePhysical,
      onUpdatePhysical,
      onSelectAtonOnMap,
    } = useAtonContext();
    const { messages } = useLocalization();
    const dialogTitle =
      mutateType === 'create'
        ? messages.atonPhysicalDialogCreateTitle
        : messages.atonPhysicalDialogEditTitle;

    const onSubmit = useMemo(() => {
      if (mutateType === 'create') {
        return onCreatePhysical;
      }
      return onUpdatePhysical;
    }, []);

    const { data: groups, isLoading: isLoadingGroups } = useGetShareGroups();

    const { onStartDrawingFromDialog } = useDrawFromDialog(
      form,
      setShowDialog,
      'geometry',
      DrawingStyles.aton
    );

    const handleOpenChange = (isOpen: boolean) => {
      setShowDialog(isOpen);
    };

    return (
      <Form {...form}>
        <DialogForm
          showDialog={showDialog}
          onOpenChange={handleOpenChange}
          title={dialogTitle}
          isLoading={isLoadingGroups}
          hasLoaded={!isLoadingGroups && !!groups}
          buttonId="submit-physical-aton-button"
          buttonText={
            isSubmitting ? messages.genericSubmitting : messages.genericSubmit
          }
          buttonDisabled={isSubmitting}
          buttonOnClick={form.handleSubmit(onSubmit)}
        >
          <div className="space-y-6">
            <div
              className={cn(
                'flex flex-row items-center justify-between border rounded-lg p-4'
              )}
            >
              <div className="space-y-0.5">
                <Label className="text-base">{messages.atonPhysicalDialogSelectAtonLabel}</Label>
                <FormDescription>
                  {messages.atonPhysicalDialogFormDescriptionPlaceholder}
                </FormDescription>
              </div>
              <Button variant="outline" size="icon" onClick={onSelectAtonOnMap}>
                <PiDiamond className="h-5 w-5" />
              </Button>
            </div>

            <MutatePhysicalForm
              form={form}
              onStartDrawing={onStartDrawingFromDialog}
            ></MutatePhysicalForm>
          </div>
        </DialogForm>
      </Form>
    );
  }
);
